export default "__VITE_ASSET__8b79de4c__"